import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const companyInfo = [
  { label: "商号", value: "株式会社LoB" },
  { label: "代表者", value: "代表取締役 田中 凌" },
  { label: "所在地", value: "〒155-0031 東京都世田谷区北沢2-30-14 重宗ビル3F" },
  { label: "設立日", value: "2026年9月2日" },
  { label: "資本金", value: "5,000,000円" },
  {
    label: "事業内容",
    value:
      "広告代理業、WEB広告運用、広告クリエイティブ制作・改善、LP制作・改善、マーケティング支援",
  },
];

export default function Company() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section
      id="company"
      ref={ref}
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-4xl mx-auto">
        <div
          className={`section-animate ${isVisible ? "visible" : ""} text-center mb-12 md:mb-16`}
        >
          <p className="text-xs md:text-sm tracking-[0.3em] text-text-muted mb-2">
            COMPANY
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            会社概要
          </h2>
        </div>

        <div
          className={`section-animate section-animate-delay-1 ${
            isVisible ? "visible" : ""
          } flex flex-col md:flex-row items-center gap-8 md:gap-12 mb-12 md:mb-16`}
        >
          <div className="shrink-0">
            <div className="w-28 h-28 md:w-32 md:h-32 flex items-center justify-center border border-border/60">
              <img
                src="https://storage.helloreaddy.io/project_files/67d84fd7-5259-43f2-8b88-812a2bb89269/f83d7469-783e-44bd-9e91-f7bdebd3e0c4_compressed_LoB_.webp"
                alt="株式会社LoB"
                className="w-24 h-24 md:w-28 md:h-28 object-contain"
              />
            </div>
          </div>
          <div className="text-center md:text-left">
            <h3 className="text-lg md:text-xl font-bold text-white mb-2">
              株式会社LoB
            </h3>
            <p className="text-xs md:text-sm tracking-[0.2em] text-text-muted">
              LoB Co., Ltd.
            </p>
          </div>
        </div>

        <div
          className={`section-animate section-animate-delay-2 ${
            isVisible ? "visible" : ""
          } border border-border/60`}
        >
          {companyInfo.map((item, index) => (
            <div
              key={item.label}
              className={`flex flex-col sm:flex-row gap-2 sm:gap-6 px-6 py-5 md:px-8 md:py-6 ${
                index < companyInfo.length - 1 ? "border-b border-border/50" : ""
              }`}
            >
              <div className="sm:w-32 md:w-40 shrink-0">
                <span className="text-xs md:text-sm tracking-[0.15em] text-text-muted">
                  {item.label}
                </span>
              </div>
              <div className="flex-1">
                <p className="text-sm md:text-base text-white leading-relaxed">
                  {item.value}
                </p>
              </div>
            </div>
          ))}

          <div className="flex flex-col sm:flex-row gap-2 sm:gap-6 px-6 py-5 md:px-8 md:py-6">
            <div className="sm:w-32 md:w-40 shrink-0">
              <span className="text-xs md:text-sm tracking-[0.15em] text-text-muted">
                メール
              </span>
            </div>
            <div className="flex-1">
              <a
                href="mailto:info@lob-official.com"
                className="text-sm md:text-base text-accent hover:text-accent-light transition-colors duration-300 cursor-pointer break-all"
              >
                info@lob-official.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}